import { useI18n } from '@cascade/react/i18n';
import { Badge, Button, Card, Text } from '@cascade/ui-library';
import classes from './GenerationFailed.module.scss';
import type { TGenerationFailedProps } from './GenerationFailed.types.ts';

export const GenerationFailed = ({ onRetry }: TGenerationFailedProps) => {
  const { translate } = useI18n();

  return (
    <Card variant='warning' fillVariant padding='md' borderRadius='md'>
      <div className={classes['generation-failed']} role='alert'>
        <Badge
          label={translate('experience.content.failed.badge')}
          iconType='triangle-exclamation'
          variant='warning-lighter'
          size='sm'
        />
        <Text
          type='body-2'
          weight='semibold'
          content={translate('experience.content.failed.title')}
        />
        <Text
          type='caption'
          color='text-60'
          content={translate('experience.content.failed.description')}
        />
        <Button
          variant='secondary'
          size='sm'
          label={translate('experience.content.retry')}
          onClick={onRetry}
        />
      </div>
    </Card>
  );
};
